export default {
  // Search related
  searchPlaceholder: "Search address/hash/investigation user ID",
  dataDetails: "Data Details",

  // Page title
  addressDetails: "Address Details",
  contractDetails: "Contract Details",

  // Buttons
  joinCanvas: "Add to Canvas",
  multiCurrencyCanvas: "Multi-Currency Canvas",
  singleCurrencyCanvas: "Single Currency Canvas",
  joinMonitor: "Add to Monitor",
  browserView: "View in Browser",

  // Dialog
  addMonitorTitle: "Add Monitor",

  // Message prompts
  copySuccess: "Copy successful!",
  addressNotFound: "Address not found",
  traceabilityDialog: {
    title: "Traceability",
    strategyName: "Strategy Name",  
    strategyId: "Strategy ID",
    strategyRunTime: "Strategy Run Time",
    dependency: "Dependency",
    hitRules: "Hit Rules",
  },
  missingTagDialog: {
    title: "Missing Tag",
    addressLabel: "Address",
    missingTagLabel: "Missing Tag",
    missingTagPlaceholder: "Please select a missing tag",
    platformCnLabel: "Platform Chinese Name",
    platformCnPlaceholder: "Please select a platform Chinese name",
    reasonLabel: "Missing Reason",
    reasonPlaceholder: "Please enter the missing reason",
    cancel: "Cancel",
    confirm: "Confirm",
    addressEmpty: "Address is empty",
    missingTagEmpty: "Please select a missing tag",
    platformCnEmpty: "Please select a platform Chinese name",
    reasonEmpty: "Please enter the missing reason",
    success: "Added successfully",
  },
  correctionDialog: {
    title: "Correction",
    tagNameLabel: "Tag Name",
    tagNamePlaceholder: "Please enter the tag name",
    errorTypeLabel: "Error Type",
    errorTypePlaceholder: "Please select an error type",
    errorReasonLabel: "Error Reason",
    errorReasonPlaceholder: "Please enter the error reason",
    cancel: "Cancel",
    confirm: "Confirm",
    tagNameEmpty: "Please enter the tag name",
    errorTypeEmpty: "Please select an error type",
    errorReasonEmpty: "Please enter the error reason",
    success: "Submitted successfully",
  },
  // Counterparty related
  rival: {
    // Search form
    dataSource: "Data Source",
    transactionDirection: "Transaction Direction",
    currency: "Currency",
    counterpartyPlaceholder: "Enter counterparty address",
    pleaseSelect: "Please select",
    totalAmount: "Total Amount",
    transactionCount: "Transaction Count",
    minAmount: "Min Amount",
    maxAmount: "Max Amount",
    maxAmountValidation: "Max amount must be ≥ min amount",
    reset: "Reset",
    search: "Search",
    
    // Data statistics
    totalData: "Total",
    dataCount: "records",
    
    // Loading
    loading: "Loading...",
    
    // Table columns
    direction: "Transaction Direction",
    counterparty: "Counterparty",
    count: "Transaction Count",
    totalQuantity: "Total Transaction Amount",
    
    // Transaction direction options
    inflow: "Deposit",
    outflow: "Withdrawal",
    
    // Data source options
    onChainData: "On-Chain Data",
    platformInternal: "Platform Internal",
    
    // Empty data prompt
    emptyText: "No deposit/withdrawal transaction data found in the current investigation file",
    
    // Download
    downloadDetails: "Download Details",
  },
};
